import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { ButtonClickedEvent, ClearFilterEvent, ErrorStateEvent, FilterClickedEvent, TileClickedEvent, TilesRenderedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { AtlassianProductHostingType, CloudFortifiedStatusValues } from '@atlassian/mpac-types';
import { getAnalyticsFilterOption, getAnalyticsFilters } from '../../AnalyticsUtils';
import { ANALYTICS_ACTION_SUBJECT_ID } from '../../constants';
export const isAppCloudSecurityParticipant = app => {
  var _app$programs;
  return isBugBountyParticipant(AtlassianProductHostingType.Cloud, app === null || app === void 0 ? void 0 : (_app$programs = app.programs) === null || _app$programs === void 0 ? void 0 : _app$programs.bugBountyParticipant) && app.deployments.includes('cloud');
};
export const isAppCloudFortified = app => {
  var _app$programs2, _app$programs2$cloudF;
  return ((_app$programs2 = app.programs) === null || _app$programs2 === void 0 ? void 0 : (_app$programs2$cloudF = _app$programs2.cloudFortified) === null || _app$programs2$cloudF === void 0 ? void 0 : _app$programs2$cloudF.status) === CloudFortifiedStatusValues.Approved;
};

// eslint-disable-next-line max-lines-per-function
export const useSearchPageAnalytics = () => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleErrorStateAnalytics = _ref => {
    let {
      actionSubjectId,
      errorType
    } = _ref;
    fireAnalyticsEvent({
      eventType: ErrorStateEvent,
      actionSubjectId,
      attributes: {
        errorType
      }
    });
  };
  const handleFilterSelectionAnalytics = _ref2 => {
    let {
      filterType,
      filterValue
    } = _ref2;
    fireAnalyticsEvent({
      eventType: FilterClickedEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.FILTER_OPTION_SELECTED,
      attributes: {
        filterType,
        filterValue: getAnalyticsFilterOption(filterValue)
      }
    });
  };
  const handleClearSelectionAnalytics = _ref3 => {
    let {
      filterType
    } = _ref3;
    fireAnalyticsEvent({
      eventType: ClearFilterEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.CLEAR_FILTER_CLICKED,
      attributes: {
        filterType
      }
    });
  };
  const handleClearAllFiltersAnalytics = _ref4 => {
    let {
      filters
    } = _ref4;
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.CLEAR_ALL_FILTERS_CLICKED,
      attributes: {
        filters: getAnalyticsFilters(filters)
      }
    });
  };
  const handleTilesRenderedAnalytics = _ref5 => {
    let {
      filters,
      count
    } = _ref5;
    fireAnalyticsEvent({
      eventType: TilesRenderedEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_TILES_RENDERED,
      attributes: {
        filters: getAnalyticsFilters(filters),
        count
      }
    });
  };
  const handleTileClickAnalytics = _ref6 => {
    let {
      tileData,
      hitRank,
      filters
    } = _ref6;
    fireAnalyticsEvent({
      eventType: TileClickedEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_TILE_CLICKED,
      attributes: {
        label: tileData.addonKey,
        appName: tileData.name,
        hitRank,
        filters: getAnalyticsFilters(filters),
        currentPerspective: 'search',
        hitSize: 'large',
        hasCloudSecurityBadge: isAppCloudSecurityParticipant(tileData),
        hasCloudFortifiedBadge: isAppCloudFortified(tileData)
      }
    });
  };
  const handleLoadMoreClickAnalytics = _ref7 => {
    let {
      pageNumber,
      filters
    } = _ref7;
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.LOAD_MORE_CLICKED,
      attributes: {
        pageNumber,
        filters: getAnalyticsFilters(filters)
      }
    });
  };
  const handleApplyFiltersClickAnalytics = _ref8 => {
    let {
      filters
    } = _ref8;
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.APPLY_FILTERS_CLICKED,
      attributes: {
        filters: getAnalyticsFilters(filters)
      }
    });
  };
  const handleYourSearchQueryClickAnalytics = _ref9 => {
    let {
      query
    } = _ref9;
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.YOUR_SEARCH_QUERY_CLICKED,
      attributes: {
        query
      }
    });
  };
  const handleFilterErrorStateAnalytics = _ref10 => {
    let {
      currentFilterState
    } = _ref10;
    const filterTypes = Object.keys(currentFilterState).filter(filterId => currentFilterState[filterId] === 'error');
    if (filterTypes.length) {
      fireAnalyticsEvent({
        eventType: ErrorStateEvent,
        actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.FILTER_OPTIONS_ERROR_RENDERED,
        attributes: {
          filterTypes
        }
      });
    }
  };
  return {
    handleErrorStateAnalytics,
    handleFilterSelectionAnalytics,
    handleClearSelectionAnalytics,
    handleClearAllFiltersAnalytics,
    handleTilesRenderedAnalytics,
    handleTileClickAnalytics,
    handleLoadMoreClickAnalytics,
    handleApplyFiltersClickAnalytics,
    handleYourSearchQueryClickAnalytics,
    handleFilterErrorStateAnalytics
  };
};